import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isAdmin } = useAuth()
    const location = useLocation()

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />
    }

    // Admins should not access user dashboard - redirect to admin panel
    if (isAdmin) {
        return <Navigate to="/admin" replace />
    }

    return children
}

export default ProtectedRoute
